import React from "react"
import Header, {Footer} from './header'
import './team.css'


var team = {__html:
`
<section class="peter-river mytheme" style="padding: 50px 0; background: #2980b9 !important;" id="title">
        <div class="container">
	  <div class="row">
                <div class="col-sm-6">
                    <h1>
Team
</h1>
                    
                </div>
                <div class="col-sm-6">
                    <ul class="breadcrumb pull-right">
                        <li id="breadcrumb-menu-team-1"
        class="active">Team</li>
                    </ul>
                </div>
            </div>
        </div>
   </section>

<div class="container">
</div>
<section  id='d3_container' class="container" style="padding-top: 30px;">

<!-- fontawecome <i> tags have to go here --> 

<!-- <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.17/d3.js"> -->
<table border="0" width="95%" cellpadding="5">
<tbody>
<tr>
<td align="center" valign="top">
<div style="width: 300px; height: 230px;"><img style="height: 225px; border-radius: 50%;" src="/img/janine_team_photo.png" alt="" /></div>
<p style="color: rgba(66,66,66,1);"><strong>Janine Cheng Ph.D. - Co-founder/CEO</strong></p>
<p style="color: rgba(66,66,66,1); line-height: 1.6;" align="left">Janine loves to help clients draw insights and build solutions from their data, leveraging 5 years of industrial experience in project management, consulting and inter-disciplinary communications, as well as her technical expertise in predictive modeling, computational simulation and data analysis.</p>
<p><a href="https://www.linkedin.com/in/janinecheng"><img style="width: 60px; height: 20px; border: 0;" src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/linkedin.png" alt="" /></a></p>
</td>
<td align="center" valign="top">
<div style="width: 300px; height: 230px;"><img style="height: 225px; border-radius: 50%;" src="/img/ketan_headshot.png" alt="ketan_team_photo" /></div>
<p style="color: rgba(66,66,66,1);"><strong>Ketan Patel Ph.D. - Co-founder/Chief Data Scientist</strong></p>
<p style="color: rgba(66,66,66,1); line-height: 1.6;" align="left">Ketan is focused on building end-to-end data solutions for customers utilizing more than a decade of experience in algorithm design and product commercialization.</p>
<p><a href="https://www.linkedin.com/in/knpatel401"><img style="width: 60px; height: 20px; border: 0;" src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/linkedin.png" alt="" /></a></p>
</td>
<td align="center" valign="top">
<div style="width: 300px; height: 230px;"><img style="height: 225px; border-radius: 50%;" src="/img/anthony_team_photo.png" alt="" /></div>
<p style="color: rgba(66,66,66,1);"><strong>Anthony Kim - Data Scientist</strong></p>
<p style="color: rgba(66,66,66,1); line-height: 1.6;" align="left">Anthony has a strong academic and professional background in public policy, and as a data scientist he specializes in predictive analytics, helping customers draw and contextualize valuable insights from their data.</p>
<p><a href="https://www.linkedin.com/in/ak2912"><img style="width: 60px; height: 20px; border: 0;" src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/linkedin.png" alt="" /></a></p>
</td>
<td align="center" valign="top">
<div style="width: 300px; height: 230px;"><img style="height: 225px; border-radius: 50%;" src="/img/nate_team_photo.png" alt="" /></div>
<p style="color: rgba(66,66,66,1);"><strong>Nathan Wieneke - Data Scientist</strong></p>
<p style="color: rgba(66,66,66,1); line-height: 1.6;" align="left">Nathan utilizes his experience with Natural Language Processing and Customer Support to build social media analytics tools that provide invaluable customer&nbsp;segmentation and&nbsp;insights.</p>
<p><a href="https://www.linkedin.com/in/nathanwieneke"><img style="width: 60px; height: 20px; border: 0;" src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/linkedin.png" alt="" /></a></p>
</td>
</tr>
</tbody>
</table>


</section>

`}



const Team = () => (
   <div>
      <Header />
   <div dangerouslySetInnerHTML={team} />
      <Footer />
      </div>
)

export default Team



/** WEBPACK FOOTER **
 ** ./src/pages/team.js
 **/